/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Qwick Core API
 * AKA V3, AKA Gigpro, AKA sidegig-api
 * OpenAPI spec version: 0.0.0
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GigsterProfileExtendedReadonly,
  HireCandidateJobCandidate,
  JobPostingApplyRequest,
  JobPostingProDetail,
  JobWithdrawRequest,
  PaginatedJobPostingProList,
  ProAIScreeningInvite,
  ProBadge,
  ProJobPostingsListParams
} from '../model';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getProRetrieveUrl = (uuid: string,) => {




  return `/api/pro/${uuid}/`
}

export const proRetrieve = async (uuid: string, options?: Parameters<typeof customFetch>[1]): Promise<GigsterProfileExtendedReadonly> => {

  return customFetch<GigsterProfileExtendedReadonly>(getProRetrieveUrl(uuid),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProRetrieveQueryKey = (uuid: string,) => {
    return [
    `/api/pro/${uuid}/`
    ] as const;
    }


export const getProRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof proRetrieve>>, TError = void>(uuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProRetrieveQueryKey(uuid);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof proRetrieve>>> = ({ signal }) => proRetrieve(uuid, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: uuid !== null && uuid !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof proRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof proRetrieve>>>
export type ProRetrieveQueryError = void


export function useProRetrieve<TData = Awaited<ReturnType<typeof proRetrieve>>, TError = void>(
 uuid: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof proRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof proRetrieve>>,
          TError,
          Awaited<ReturnType<typeof proRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProRetrieve<TData = Awaited<ReturnType<typeof proRetrieve>>, TError = void>(
 uuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof proRetrieve>>,
          TError,
          Awaited<ReturnType<typeof proRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProRetrieve<TData = Awaited<ReturnType<typeof proRetrieve>>, TError = void>(
 uuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useProRetrieve<TData = Awaited<ReturnType<typeof proRetrieve>>, TError = void>(
 uuid: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProRetrieveQueryOptions(uuid,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getProBadgeRetrieveUrl = () => {




  return `/api/pro/badge/`
}

/**
 * The pro app's badge count, as one cheap read.
 *
 * Returns the same number the push notifications carry, so the app icon and the server stop
 * disagreeing. The app previously derived it from ``/gigs/v2/scheduled/`` -- a full schedule payload
 * subscribed app-wide for the whole session, at roughly 17 queries a call, to render two integers.
 *
 * Sendbird unread is deliberately absent: it lives in an external service, and calling out to it
 * would put a network hop in a hot path. The client adds it on top, as it already does.
 *
 * No ``LastActivityMixin``: polling a badge is not the pro doing something, and the mixin enqueues a
 * task per call.
 */
export const proBadgeRetrieve = async ( options?: Parameters<typeof customFetch>[1]): Promise<ProBadge> => {

  return customFetch<ProBadge>(getProBadgeRetrieveUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProBadgeRetrieveQueryKey = () => {
    return [
    `/api/pro/badge/`
    ] as const;
    }


export const getProBadgeRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof proBadgeRetrieve>>, TError = void>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proBadgeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProBadgeRetrieveQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof proBadgeRetrieve>>> = ({ signal }) => proBadgeRetrieve({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof proBadgeRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProBadgeRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof proBadgeRetrieve>>>
export type ProBadgeRetrieveQueryError = void


export function useProBadgeRetrieve<TData = Awaited<ReturnType<typeof proBadgeRetrieve>>, TError = void>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof proBadgeRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof proBadgeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof proBadgeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProBadgeRetrieve<TData = Awaited<ReturnType<typeof proBadgeRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proBadgeRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof proBadgeRetrieve>>,
          TError,
          Awaited<ReturnType<typeof proBadgeRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProBadgeRetrieve<TData = Awaited<ReturnType<typeof proBadgeRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proBadgeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useProBadgeRetrieve<TData = Awaited<ReturnType<typeof proBadgeRetrieve>>, TError = void>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proBadgeRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProBadgeRetrieveQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getProJobPostingsListUrl = (params?: ProJobPostingsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/pro/job-postings/?${stringifiedParams}` : `/api/pro/job-postings/`
}

/**
 * Job postings for pro users (list and detail).
 *
 * Scope:
 * - scope=MARKET (default): Open jobs in pro's market, excluding already applied
 * - scope=APPLIED: All jobs pro has applied to (regardless of job status)
 * - scope=MATCHED: Jobs where pro was matched
 * - scope=JOB_OFFERED: Open jobs where pro has a pending job offer (JOB_OFFERED stage)
 *
 * Filters (all scopes):
 * - location_id: Filter by location ID
 * - position: Filter by position/skill ID
 * - job_type: Filter by job type ID(s) (comma-separated)
 * - experience_level: Filter by experience level ID(s) (comma-separated)
 * - wage__gte: Minimum hourly rate
 *
 * Ordering (all scopes):
 * - created_ts: Date posted (default: -created_ts for newest first)
 * - wage: Compensation (use -wage for highest pay first)
 * - distance_concat_sort_cursor: Distance (requires lon/lat params, closest first)
 */
export const proJobPostingsList = async (params?: ProJobPostingsListParams, options?: Parameters<typeof customFetch>[1]): Promise<PaginatedJobPostingProList> => {

  return customFetch<PaginatedJobPostingProList>(getProJobPostingsListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProJobPostingsListInfiniteQueryKey = (params?: ProJobPostingsListParams,) => {
    return [
    'infinite', `/api/pro/job-postings/`, ...(params ? [params] : [])
    ] as const;
    }

export const getProJobPostingsListQueryKey = (params?: ProJobPostingsListParams,) => {
    return [
    `/api/pro/job-postings/`, ...(params ? [params] : [])
    ] as const;
    }


export const getProJobPostingsListInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof proJobPostingsList>>, ProJobPostingsListParams['page']>, TError = void>(params?: ProJobPostingsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof proJobPostingsList>>, TError, TData, QueryKey, ProJobPostingsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProJobPostingsListInfiniteQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof proJobPostingsList>>, QueryKey, ProJobPostingsListParams['page']> = ({ signal, pageParam }) => proJobPostingsList({...params, 'page': pageParam ?? params?.['page']}, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof proJobPostingsList>>, TError, TData, QueryKey, ProJobPostingsListParams['page']> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProJobPostingsListInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof proJobPostingsList>>>
export type ProJobPostingsListInfiniteQueryError = void


export function useProJobPostingsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof proJobPostingsList>>, ProJobPostingsListParams['page']>, TError = void>(
 params: undefined |  ProJobPostingsListParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof proJobPostingsList>>, TError, TData, QueryKey, ProJobPostingsListParams['page']>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof proJobPostingsList>>,
          TError,
          Awaited<ReturnType<typeof proJobPostingsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProJobPostingsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof proJobPostingsList>>, ProJobPostingsListParams['page']>, TError = void>(
 params?: ProJobPostingsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof proJobPostingsList>>, TError, TData, QueryKey, ProJobPostingsListParams['page']>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof proJobPostingsList>>,
          TError,
          Awaited<ReturnType<typeof proJobPostingsList>>, QueryKey
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProJobPostingsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof proJobPostingsList>>, ProJobPostingsListParams['page']>, TError = void>(
 params?: ProJobPostingsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof proJobPostingsList>>, TError, TData, QueryKey, ProJobPostingsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useProJobPostingsListInfinite<TData = InfiniteData<Awaited<ReturnType<typeof proJobPostingsList>>, ProJobPostingsListParams['page']>, TError = void>(
 params?: ProJobPostingsListParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof proJobPostingsList>>, TError, TData, QueryKey, ProJobPostingsListParams['page']>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProJobPostingsListInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getProJobPostingsListQueryOptions = <TData = Awaited<ReturnType<typeof proJobPostingsList>>, TError = void>(params?: ProJobPostingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proJobPostingsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProJobPostingsListQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof proJobPostingsList>>> = ({ signal }) => proJobPostingsList(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof proJobPostingsList>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProJobPostingsListQueryResult = NonNullable<Awaited<ReturnType<typeof proJobPostingsList>>>
export type ProJobPostingsListQueryError = void


export function useProJobPostingsList<TData = Awaited<ReturnType<typeof proJobPostingsList>>, TError = void>(
 params: undefined |  ProJobPostingsListParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof proJobPostingsList>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof proJobPostingsList>>,
          TError,
          Awaited<ReturnType<typeof proJobPostingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProJobPostingsList<TData = Awaited<ReturnType<typeof proJobPostingsList>>, TError = void>(
 params?: ProJobPostingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proJobPostingsList>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof proJobPostingsList>>,
          TError,
          Awaited<ReturnType<typeof proJobPostingsList>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProJobPostingsList<TData = Awaited<ReturnType<typeof proJobPostingsList>>, TError = void>(
 params?: ProJobPostingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proJobPostingsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useProJobPostingsList<TData = Awaited<ReturnType<typeof proJobPostingsList>>, TError = void>(
 params?: ProJobPostingsListParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proJobPostingsList>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProJobPostingsListQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getProJobPostingsRetrieveUrl = (id: string,) => {




  return `/api/pro/job-postings/${id}/`
}

/**
 * Job postings for pro users (list and detail).
 *
 * Scope:
 * - scope=MARKET (default): Open jobs in pro's market, excluding already applied
 * - scope=APPLIED: All jobs pro has applied to (regardless of job status)
 * - scope=MATCHED: Jobs where pro was matched
 * - scope=JOB_OFFERED: Open jobs where pro has a pending job offer (JOB_OFFERED stage)
 *
 * Filters (all scopes):
 * - location_id: Filter by location ID
 * - position: Filter by position/skill ID
 * - job_type: Filter by job type ID(s) (comma-separated)
 * - experience_level: Filter by experience level ID(s) (comma-separated)
 * - wage__gte: Minimum hourly rate
 *
 * Ordering (all scopes):
 * - created_ts: Date posted (default: -created_ts for newest first)
 * - wage: Compensation (use -wage for highest pay first)
 * - distance_concat_sort_cursor: Distance (requires lon/lat params, closest first)
 */
export const proJobPostingsRetrieve = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<JobPostingProDetail> => {

  return customFetch<JobPostingProDetail>(getProJobPostingsRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getProJobPostingsRetrieveQueryKey = (id: string,) => {
    return [
    `/api/pro/job-postings/${id}/`
    ] as const;
    }


export const getProJobPostingsRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof proJobPostingsRetrieve>>, TError = void>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proJobPostingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getProJobPostingsRetrieveQueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof proJobPostingsRetrieve>>> = ({ signal }) => proJobPostingsRetrieve(id, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof proJobPostingsRetrieve>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ProJobPostingsRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof proJobPostingsRetrieve>>>
export type ProJobPostingsRetrieveQueryError = void


export function useProJobPostingsRetrieve<TData = Awaited<ReturnType<typeof proJobPostingsRetrieve>>, TError = void>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof proJobPostingsRetrieve>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof proJobPostingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof proJobPostingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProJobPostingsRetrieve<TData = Awaited<ReturnType<typeof proJobPostingsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proJobPostingsRetrieve>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof proJobPostingsRetrieve>>,
          TError,
          Awaited<ReturnType<typeof proJobPostingsRetrieve>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useProJobPostingsRetrieve<TData = Awaited<ReturnType<typeof proJobPostingsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proJobPostingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useProJobPostingsRetrieve<TData = Awaited<ReturnType<typeof proJobPostingsRetrieve>>, TError = void>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof proJobPostingsRetrieve>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getProJobPostingsRetrieveQueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getProJobPostingsAiScreeningCreateUrl = (id: string,) => {




  return `/api/pro/job-postings/${id}/ai-screening/`
}

/**
 * Start the optional AI screening call for the pro's OWN application to this posting. Mints (or idempotently re-returns) the vendor invite and returns the ``url`` the app opens in a WebView (201 on a fresh mint, 200 when an invite is already outstanding). 404 if the pro has no application for this posting. No SMS/push is sent — the pro starts the call live in-app, so the notification the manager-initiated send fires is suppressed.
 */
export const proJobPostingsAiScreeningCreate = async (id: string, options?: Parameters<typeof customFetch>[1]): Promise<ProAIScreeningInvite> => {

  return customFetch<ProAIScreeningInvite>(getProJobPostingsAiScreeningCreateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getProJobPostingsAiScreeningCreateMutationKey = () => ['proJobPostingsAiScreeningCreate'] as const;

export const getProJobPostingsAiScreeningCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proJobPostingsAiScreeningCreate>>, TError,ProJobPostingsAiScreeningCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proJobPostingsAiScreeningCreate>>, TError,ProJobPostingsAiScreeningCreateMutationVariables, TContext> => {

const mutationKey = getProJobPostingsAiScreeningCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proJobPostingsAiScreeningCreate>>, ProJobPostingsAiScreeningCreateMutationVariables> = (props) => {
          const {id} = props ?? {};

          return  proJobPostingsAiScreeningCreate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProJobPostingsAiScreeningCreateMutationResult = NonNullable<Awaited<ReturnType<typeof proJobPostingsAiScreeningCreate>>>

    export type ProJobPostingsAiScreeningCreateMutationError = void
    export type ProJobPostingsAiScreeningCreateMutationVariables = {id: string}

    export const useProJobPostingsAiScreeningCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proJobPostingsAiScreeningCreate>>, TError,ProJobPostingsAiScreeningCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proJobPostingsAiScreeningCreate>>,
        TError,
        ProJobPostingsAiScreeningCreateMutationVariables,
        TContext
      > => {
      return useMutation(getProJobPostingsAiScreeningCreateMutationOptions(options), queryClient);
    }
    export const getProJobPostingsApplyCreateUrl = (id: string,) => {




  return `/api/pro/job-postings/${id}/apply/`
}

/**
 * Apply to a job posting as a pro.
 *
 * When the posting requires a screening questionnaire, a complete answer
 * set must be included in the request body under ``answers`` (single call);
 * otherwise no answers may be submitted. See ``JobPostingService.apply``.
 */
export const proJobPostingsApplyCreate = async (id: string,
    jobPostingApplyRequest?: JobPostingApplyRequest, options?: Parameters<typeof customFetch>[1]): Promise<HireCandidateJobCandidate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<HireCandidateJobCandidate>(getProJobPostingsApplyCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(jobPostingApplyRequest)
  }
);}





export const getProJobPostingsApplyCreateMutationKey = () => ['proJobPostingsApplyCreate'] as const;

export const getProJobPostingsApplyCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proJobPostingsApplyCreate>>, TError,ProJobPostingsApplyCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proJobPostingsApplyCreate>>, TError,ProJobPostingsApplyCreateMutationVariables, TContext> => {

const mutationKey = getProJobPostingsApplyCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proJobPostingsApplyCreate>>, ProJobPostingsApplyCreateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  proJobPostingsApplyCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProJobPostingsApplyCreateMutationResult = NonNullable<Awaited<ReturnType<typeof proJobPostingsApplyCreate>>>
    export type ProJobPostingsApplyCreateMutationBody = JobPostingApplyRequest | undefined
    export type ProJobPostingsApplyCreateMutationError = void
    export type ProJobPostingsApplyCreateMutationVariables = {id: string;data?: JobPostingApplyRequest}

    export const useProJobPostingsApplyCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proJobPostingsApplyCreate>>, TError,ProJobPostingsApplyCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proJobPostingsApplyCreate>>,
        TError,
        ProJobPostingsApplyCreateMutationVariables,
        TContext
      > => {
      return useMutation(getProJobPostingsApplyCreateMutationOptions(options), queryClient);
    }
    export const getProJobPostingsWithdrawCreateUrl = (id: string,) => {




  return `/api/pro/job-postings/${id}/withdraw/`
}

/**
 * Withdraw the pro's own submitted application. Gated first so an un-flagged pro can't tell the
 * endpoint exists (not even via body-validation errors). See ``JobPostingService.withdraw``.
 */
export const proJobPostingsWithdrawCreate = async (id: string,
    jobWithdrawRequest: JobWithdrawRequest, options?: Parameters<typeof customFetch>[1]): Promise<HireCandidateJobCandidate> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customFetch<HireCandidateJobCandidate>(getProJobPostingsWithdrawCreateUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(jobWithdrawRequest)
  }
);}





export const getProJobPostingsWithdrawCreateMutationKey = () => ['proJobPostingsWithdrawCreate'] as const;

export const getProJobPostingsWithdrawCreateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proJobPostingsWithdrawCreate>>, TError,ProJobPostingsWithdrawCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof proJobPostingsWithdrawCreate>>, TError,ProJobPostingsWithdrawCreateMutationVariables, TContext> => {

const mutationKey = getProJobPostingsWithdrawCreateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof proJobPostingsWithdrawCreate>>, ProJobPostingsWithdrawCreateMutationVariables> = (props) => {
          const {id,data} = props ?? {};

          return  proJobPostingsWithdrawCreate(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ProJobPostingsWithdrawCreateMutationResult = NonNullable<Awaited<ReturnType<typeof proJobPostingsWithdrawCreate>>>
    export type ProJobPostingsWithdrawCreateMutationBody = JobWithdrawRequest
    export type ProJobPostingsWithdrawCreateMutationError = void
    export type ProJobPostingsWithdrawCreateMutationVariables = {id: string;data: JobWithdrawRequest}

    export const useProJobPostingsWithdrawCreate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof proJobPostingsWithdrawCreate>>, TError,ProJobPostingsWithdrawCreateMutationVariables, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof proJobPostingsWithdrawCreate>>,
        TError,
        ProJobPostingsWithdrawCreateMutationVariables,
        TContext
      > => {
      return useMutation(getProJobPostingsWithdrawCreateMutationOptions(options), queryClient);
    }
